<script lang="ts">
    import type { Image } from "./types";

    // Props passed into the component
    export let image: Image;
    export let loading: "eager" | "lazy" | undefined = undefined;
    export let className = "";

    function imageUrl(width: number) {
        let completeUrl = image.src.startsWith("http")
            ? image.src
            : `https:${image.src}`;
        const url = new URL(completeUrl);
        url.searchParams.set("width", width.toString());
        return url.toString();
    }

    const widths = [300, 600, 800, 1000, 1200, 1600, 2000];
    const srcset = widths.map((w) => `${imageUrl(w)} ${w}w`).join(", ");

    const sizes = `
    (max-width: 300px) 280px,
    (max-width: 600px) 560px,
    (max-width: 800px) 800px,
    (max-width: 1000px) 1000px,
    (max-width: 1200px) 1200px,
    (max-width: 1600px) 1600px,
    (max-width: 2000px) 2000px
  `;
</script>

<img
    loading={loading === "eager" ? "eager" : "lazy"}
    width={image.width}
    height={image.height}
    src={imageUrl(image.width)}
    {srcset}
    {sizes}
    alt={image.alt}
    class={className}
/>
